// extracted by mini-css-extract-plugin
export default {"container":"Header_container__TsUVY","techniusLogo":"Header_techniusLogo__MgZY9","navLink":"Header_navLink__zcwsQ","icons":"Header_icons__dZ1Ja","iconLink":"Header_iconLink__pMrU8"};